export class PaginatorHook{
    paginator: boolean=false;
    rows:number=10;
    rowsPerPageOptions: any[]=[10,15,20];
    totalRecords:number;
    url:string;    
}